module.exports = __webpack_public_path__ + "static/img/video_null.9fe94121.png";